'use client';

import { useState } from 'react';
import { cn } from '@/lib/utils';
import { ChevronDown } from 'lucide-react';

export default function FAQAccordion({
  itemKey,
  question,
  answer,
}: {
  itemKey: string;
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="rounded-lg overflow-hidden transition-colors duration-300 bg-[#F0EDE5]">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer text-[#1A1A2E]"
      >
        <span className="font-medium text-sm pr-4">{question}</span>
        <ChevronDown
          className={cn(
            'w-5 h-5 flex-shrink-0 text-[#9B7B3A] transition-transform duration-200',
            isOpen && 'rotate-180'
          )}
        />
      </button>

      {isOpen && (
        <div className="px-5 pb-4 text-sm leading-relaxed text-[#5A5A6E]">
          {answer}
        </div>
      )}
    </div>
  );
}
